import { render } from "./TableWithBorder.vue?vue&type=template&id=55210488&ts=true"
import script from "./TableWithBorder.vue?vue&type=script&lang=ts"
export * from "./TableWithBorder.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__